import { extendObservable } from 'mobx'

export default class TrailModel {
  constructor (data) {
    extendObservable(this, {
      id: data.id,
      created_by: data.created_by,
      disciplines: data.disciplines || [],
      name: data.name,
      integration_code: data.integration_code,
      issues_certificate: data.issues_certificate,
      is_nr: data.is_nr,
      start_date: data.start_date,
      completed: data.completed,
      institution_name: data.institution_name,
      producer: data.producer,
      author: data.author,
      certificate_validity_years: data.certificate_validity_years,
      nr_instructor: data.nr_instructor,
      nr_technical_responsible: data.nr_technical_responsible,
      nr_ordinance: data.nr_ordinance,
      nr_address: data.nr_address,
      nr_programmatic_content: data.nr_programmatic_content,
      created_at: data.created_at,
      updated_at: data.updated_at,
      deleted_at: data.deleted_at,
      institution: data.institution
    })
  }
}
